import React from 'react'
import { Typography } from '@material-ui/core'
import ManageUsers from '../ManageUsers'

export function UsersSection() {
    return (
        <>
            <Typography variant="h6" gutterBottom>
                User Management
            </Typography>
            <ManageUsers />
        </>
    )
}
